import React from "react"
import { Link, graphql } from "gatsby"

import { rhythm } from "../utils/typography"
import { FaTags } from "react-icons/fa"
import kebabCase from "lodash/kebabCase"

import Layout from "../components/layout"
import Bio from "../components/bio"
import SEO from "../components/seo"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article>
          <header>
            <p
              style={{
                marginTop: rhythm(1),
                marginBottom: 0,
              }}
            >
              {post.frontmatter.date}
            </p>
            <h1
              style={{
                display: `block`,
                marginBottom: `0.25em`,
              }}
            >
              {post.frontmatter.title}
            </h1>
            <section id="blog-post-tags">
              <p>
                <FaTags aria-label="Tags" />&nbsp;
                {post.frontmatter.tags.map((tag) => {
                  const tagCount = post.frontmatter.tags.length
                  const tagIndex = post.frontmatter.tags.indexOf(tag)
                  const isLastTag = tagIndex === tagCount - 1
                  return (isLastTag ?
                    <Link key={tagIndex} to={`/tags/${kebabCase(tag)}`}>{tag}</Link> :
                    <span key={tagIndex}>
                      <Link key={tagIndex} to={`/tags/${kebabCase(tag)}`}>{tag}</Link>,&nbsp;
                    </span>
                  )
                })}
              </p>
            </section>
          </header>
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
          <hr id="blog-footer-hr"
            style={{
              marginBottom: rhythm(1),
            }}
          />
          <footer id="blog-footer">
            <Bio />
          </footer>
        </article>

        <nav>
          <ul id="prev-next-links">
            <li id="prev-link">
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← Previous
                </Link>
              )}
            </li>
            <li id="next-link">
              {next && (
                <Link to={next.fields.slug} rel="next">
                  Next →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        tags
      }
    }
  }
`
